module.exports = __webpack_public_path__ + "static/media/404.6b5691ec.svg";